import React, { useState, useEffect } from 'react'
import QRCode from 'react-qr-code'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'

const IDCheckQRCode = ({ employeeID }) => {
  const url = `${window.location.origin}/id-check/${employeeID}`

  return (
    <Stack gap={1}>
      <Typography variant="title2" fontSize="1rem">
        ID Check
      </Typography>
      <QRCode value={url} />
      <Button
        onClick={() => navigator.clipboard.writeText(url)}
        startIcon={<ContentPasteIcon />}
        variant="contained"
      >
        Copy to Clipboard
      </Button>
    </Stack>
  )
}

export default IDCheckQRCode
